<template>
  <form id="customerlogin" method="post" @submit.prevent="validateAndSubmit">
    <div class="formsectioncompound">
      <div class="jq_gridcontentarea">
        <input-field
          id="username"
          :$v="$v.username"
          :value="username"
          :required="true"
          :hide-label="true"
          :placeholder="$t('loginForm.username')"
          validation-message-translation-name-space="loginForm"
          name="username"
          @input="(v) => setUsername(v)"
        />
      </div>
      <div class="jq_gridcontentarea">
        <input-field
          id="password"
          :$v="$v.password"
          :value="password"
          :required="true"
          :hide-label="true"
          :placeholder="$t('loginForm.password')"
          type="password"
          validation-message-translation-name-space="loginForm"
          name="password"
          @input="(v) => setPassword(v)"
        />
      </div>
      <div class="jq_gridcontentarea">
        <div class="wm-field large-12 columns">
          <button type="submit">
            <i class="icon-lock"/>
            {{ $t('loginForm.login') }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import InputField from './fields/InputField'
import { required } from 'vuelidate/lib/validators'
import ShowAlertErrorHandler from '../../mixins/show-alert-error-handler'

export default {
  name: 'LoginForm',
  components: {
    InputField
  },
  mixins: [ShowAlertErrorHandler],
  data: () => {
    return {
      username: '',
      password: ''
    }
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  methods: {
    setUsername (value) {
      this.username = value
    },

    setPassword (value) {
      this.password = value
    },

    validateAndSubmit () {
      if (!this.validate()) {
        return false
      }
      this.submit()
    },
    validate () {
      this.$v.$touch()
      return !this.$v.$invalid
    },

    submit () {
      this.$store.dispatch('user/userLogin', { username: this.username, password: this.password })
        .then(async () => {
          await this.$store.dispatch('company/loadSelfServiceStatus')
          this.$router.push({ name: 'home' })
        }).catch((error) => {
          this.showAlertForError(error, {
            401: this.$t('loginForm.errors.badCredentials')
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/LoginForm.vue